import type { CrawlJob, WithResourceId } from '../../types/knowledge';

export function filterCrawlsByStartUrlSearch(
  crawls: Array<WithResourceId<CrawlJob>>,
  normalizedSearch: string,
): Array<WithResourceId<CrawlJob>> {
  if (normalizedSearch === '') {
    return crawls;
  }

  return crawls.filter((crawl) =>
    (crawl.startUrl ?? '').toLowerCase().includes(normalizedSearch),
  );
}
